export default class VideoLoadingComponent {
    constructor() {
        VideoLoadingComponent.initStrateMoment()
        VideoLoadingComponent.initStrateAgenda()
    }

    static initStrateMoment() {
        const videoElmt = document.createElement('video')
        const videoSrc = document.createElement('source')
        const isVideo = $('[data-id="highlightmedia"]').data('media-type')
        const videos = $('.strate-votre-moment__highlight__media__video')

        if (isVideo === 2 && !IRISCollectionCustomer.isEcomodeActive) {
            videoSrc.type = videos.data('moment-video-type')
            videoSrc.src = videos.data('moment-video-src')
            videoElmt.muted = true
            videoElmt.loop = true

            videoElmt.appendChild(videoSrc)
            videos.append(videoElmt)
            videoElmt.play()
        }
    }

    static initStrateAgenda() {
        $('[data-id="agendaMedia"]').each(function () {
            const videoElmt = document.createElement('video')
            const videoSrc = document.createElement('source')

            const isVideo = $(this).find('.strate-agenda__item__media__video').length > 0

            if (isVideo && !IRISCollectionCustomer.isEcomodeActive) {
                videoSrc.type = $(this)
                    .find('.strate-agenda__item__media__video')
                    .data('agenda-video-type')
                videoSrc.src = $(this)
                    .find('.strate-agenda__item__media__video')
                    .data('agenda-video-src')
                videoElmt.muted = true
                videoElmt.loop = true

                videoElmt.appendChild(videoSrc)
                $(this).append(videoElmt)
                videoElmt.play()
            }
        })
    }
}
